import { push } from "react-router-redux";
import { startSubmit, stopSubmit, reset } from "redux-form";
import moment from "moment";
import api from "../services/api";
import { showError, setLoading } from "./common.actions";
import { setPagination, getProject as getAdminProject } from "./admin.actions";
import { resetTable, setTableLoading } from "./table.actions";
import { getUserStats } from "./user.actions";
import "../utils/arrays";

export const SET_LOADING_MESSAGE_ATTACHMENT = "SET_LOADING_MESSAGE_ATTACHMENT";

export const CREATE_PROJECT_START = "CREATE_PROJECT_START";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_ERROR = "CREATE_PROJECT_ERROR";

export const UPDATE_PROJECT_START = "UPDATE_PROJECT_START";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_ERROR = "UPDATE_PROJECT_ERROR";

export const HIDE_PROJECT_START = "HIDE_PROJECT_START";
export const HIDE_PROJECT_SUCCESS = "HIDE_PROJECT_SUCCESS";
export const HIDE_PROJECT_ERROR = "HIDE_PROJECT_ERROR";

export const GET_PROJECT_START = "GET_PROJECT_START";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_ERROR = "GET_PROJECT_ERROR";
export const GET_PROJECT_NULL = "GET_PROJECT_NULL";

export const SET_MATCHES = "SET_MATCHES";
export const SET_PITCHES = "SET_PITCHES";
export const SET_STATEMENTS = "SET_STATEMENTS";
export const SET_HIRED = "SET_HIRED";

export const SET_MATCH = "SET_MATCH";
export const SET_PITCH = "SET_PITCH";
export const SET_SOW = "SET_SOW";
export const SET_MESSAGES = "SET_MESSAGES";

export const SET_CANDIDATES = "SET_CANDIDATES";
export const SET_SORTED_BY = "SET_SORTED_BY";
export const DECLINE_CANDIDATE_SUCCESS = "DECLINE_CANDIDATE_SUCCESS";

export const SET_REVIEW_QUESTIONS_FOR_MEMBER =
  "SET_REVIEW_QUESTIONS_FOR_MEMBER";
export const SET_REVIEW_QUESTIONS_FOR_EMPLOYER =
  "SET_REVIEW_QUESTIONS_FOR_EMPLOYER";
export const SET_CAN_SEND_FEEDBACK = "SET_CAN_SEND_FEEDBACK";

const MUST_HAVE = "MUST_HAVE";
const NICE_HAVE = "NICE_HAVE";

export const SET_MEMBER = "SET_MEMBER";

export const GET_PROJECTS_START = "GET_PROJECTS_START";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_CSV_SUCCESS = "GET_PROJECTS_CSV_SUCCESS";
export const GET_PROJECTS_ERROR = "GET_PROJECTS_ERROR";

export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";

export const GET_ADMIN_PROJECTS_OVERVIEW_START =
  "GET_ADMIN_PROJECTS_OVERVIEW_START";
export const GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS =
  "GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS";
export const GET_ADMIN_PROJECTS_OVERVIEW_ERROR =
  "GET_ADMIN_PROJECTS_OVERVIEW_ERROR";

export const ADMIN_UPDATE_PROJECT_SUCCESS = "ADMIN_UPDATE_PROJECT_SUCCESS";

export const PROJECT_BASICS_FORM = "projectBasics";
export const PROJECT_DETAIL_FORM = "projectDetail";
export const PROJECT_PITCH_IT_FORM = "PitchItForm";
export const PROJECT_SOW_FORM = "projectSowForm";
export const PROJECT_SEND_MESSAGE_FORM = "SendMessageForm";
export const PROJECT_UPDATE_MESSAGE_FORM = "UpdateMessageForm";
export const PROJECT_FILTERS_FORM = "projectFilters";
export const PROJECT_INDEX_TABLE = "ProjectIndexTable";
export const PROJECT_MATCHES_TABLE = "MatchesTable";
export const PROJECT_PITCHES_TABLE = "PitchesTable";
export const PROJECT_SOW_TABLE = "SOWTable";
export const PROJECT_COMPLETED_TABLE = "CompletedTable";

export function onGetProjectStart() {
  return {
    type: GET_PROJECT_START
  };
}

export function onGetProjectSuccess(data) {
  return {
    type: GET_PROJECT_SUCCESS,
    data
  };
}

export function onGetProjectError() {
  return {
    type: GET_PROJECT_ERROR
  };
}

export function onGetProjectNull() {
  return {
    type: GET_PROJECT_NULL
  };
}

export function onCreateProjectStart() {
  return {
    type: CREATE_PROJECT_START
  };
}

export function onCreateProjectSuccess(data) {
  return {
    type: CREATE_PROJECT_SUCCESS,
    data
  };
}

export function onCreateProjectError() {
  return {
    type: CREATE_PROJECT_ERROR
  };
}

export function onUpdateProjectStart() {
  return {
    type: UPDATE_PROJECT_START
  };
}

export function onUpdateProjectSuccess(data) {
  return {
    type: UPDATE_PROJECT_SUCCESS,
    data
  };
}

export function onUpdateProjectError() {
  return {
    type: UPDATE_PROJECT_ERROR
  };
}

export function onHideProjectStart() {
  return {
    type: HIDE_PROJECT_START
  };
}

export function onHideProjectSuccess(data) {
  return {
    type: HIDE_PROJECT_SUCCESS,
    data
  };
}

export function onHideProjectError() {
  return {
    type: HIDE_PROJECT_ERROR
  };
}

export function onDeclineCandidateSuccess(data) {
  return {
    type: DECLINE_CANDIDATE_SUCCESS,
    data
  };
}

export function setMatches(data) {
  return {
    type: SET_MATCHES,
    data
  };
}

export function setPitches(data) {
  return {
    type: SET_PITCHES,
    data
  };
}

export function setStatements(data) {
  return {
    type: SET_STATEMENTS,
    data
  };
}

export function setMatch(match) {
  return {
    type: SET_MATCH,
    match
  };
}

export function setPitch(pitch) {
  return {
    type: SET_PITCH,
    pitch
  };
}

export function setSOW(sow) {
  return {
    type: SET_SOW,
    sow
  };
}

export function setMember(member) {
  return {
    type: SET_MEMBER,
    member
  };
}

export function onGetProjectsStart() {
  return {
    type: GET_PROJECTS_START
  };
}

export function onGetProjectsSuccess(projects) {
  return {
    type: GET_PROJECTS_SUCCESS,
    projects
  };
}

export function onGetProjectsCsvSuccess(projects) {
  return {
    type: GET_PROJECTS_CSV_SUCCESS,
    projects
  };
}

export function onGetProjectsError() {
  return {
    type: GET_PROJECTS_ERROR
  };
}

export function onGetStatusSuccess(status) {
  return {
    type: GET_STATUS_SUCCESS,
    status
  };
}

export function setReviewQuestionsForEmployers(data) {
  return {
    type: SET_REVIEW_QUESTIONS_FOR_EMPLOYER,
    data
  };
}

export function setReviewQuestionsForMembers(data) {
  return {
    type: SET_REVIEW_QUESTIONS_FOR_MEMBER,
    data
  };
}

export function setCanSendFeedback(data) {
  return {
    type: SET_CAN_SEND_FEEDBACK,
    data
  };
}

export function setCandidates(candidates) {
  return {
    type: SET_CANDIDATES,
    candidates
  };
}

export function setHired(data) {
  return {
    type: SET_HIRED,
    data
  };
}

export function setSortedBy(sortBy) {
  return {
    type: SET_SORTED_BY,
    sortBy
  };
}

export function setMessages(messages) {
  return {
    type: SET_MESSAGES,
    messages
  };
}

export function setLoadingMessageAttachment(loading) {
  return {
    type: SET_LOADING_MESSAGE_ATTACHMENT,
    loading
  };
}

export function createProject(project, redirect) {
  return dispatch => {
    dispatch(onCreateProjectStart());
    api
      .createProject(project)
      .then(res => {
        dispatch(onCreateProjectSuccess(res.data));
        dispatch(
          push({
            pathname: `/company/project/id/${res.data.data.id}/${redirect}`,
            state: { projectId: res.data.data.id }
          })
        );
      })
      .catch(error => {
        dispatch(stopSubmit(PROJECT_BASICS_FORM, error.response.data.errors));
        dispatch(onCreateProjectError());
      });
  };
}

export function getProject(projectId) {
  return dispatch => {
    dispatch(onGetProjectStart());

    if (projectId) {
      dispatch(setLoading(true));
      api
        .getProject(projectId)
        .then(res => {
          const project = res.data.data;

          project.skills = [];

          if (project.must_skills) {
            project.must_skills.map(
              skill => (project.skills[skill.skill_id] = { have: MUST_HAVE })
            );
          }

          if (project.nice_skills) {
            project.nice_skills.map(
              skill => (project.skills[skill.skill_id] = { have: NICE_HAVE })
            );
          }

          if (project.city) {
            const location = localStorage.getItem("projectLocation");
            if (location) {
              project.city_obj = JSON.parse(location);
            }
          }

          dispatch(onGetProjectSuccess(project));
        })
        .catch(() => {
          dispatch(onGetProjectError());
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    } else {
      dispatch(onGetProjectNull());
    }
  };
}

export function updateProject(
  project,
  redirect,
  projectId,
  adminEdit = false,
  loading = false
) {
  return dispatch => {
    dispatch(setLoading(loading));

    if (project.skills) {
      project.skills = project.skills.map((pro, i) => ({
        skill_id: i,
        have: pro == undefined ? null : pro.have
      }));
      if (project.skills[0]) delete project.skills[0];
      project.skills.sort();
      project.skills.clean();

      project.must_skills = project.skills
        .filter(p => p.have == MUST_HAVE)
        .map(p => ({ skill_id: p.skill_id }));
      project.nice_skills = project.skills
        .filter(p => p.have == NICE_HAVE)
        .map(p => ({ skill_id: p.skill_id }));

      delete project.skills;
    }

    // Deleting unnecesary data.
    if (project.log) delete project.log;
    if (project.notes) delete project.notes;
    if (project.matches) delete project.matches;
    if (project.reviews) delete project.reviews;

    dispatch(onUpdateProjectStart());

    api
      .updateProject(project, projectId)
      .then(res => {
        dispatch(onUpdateProjectSuccess(res.data));
        if (redirect) {
          if (adminEdit) {
            dispatch(push(`/admin/project/${projectId}/detail`));
          } else {
            dispatch(
              push(
                redirect !== "/company/projects"
                  ? `/company/project/id/${projectId}/${redirect}`
                  : localStorage.getItem("role") === "admin"
                  ? dispatch(
                      push(`/admin/project/${projectId}/potential-matches`)
                    )
                  : "/company/projects"
              )
            );
          }
        } else {
          dispatch(getProject(projectId));
        }
      })
      .catch(error => {
        dispatch(stopSubmit(PROJECT_DETAIL_FORM, error.response.data.errors));
        dispatch(onUpdateProjectError());
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function hideProject(projectId) {
  const project = {
    hide: true
  };

  return dispatch => {
    const loading = false;
    dispatch(onHideProjectStart());

    api
      .updateProject(project, projectId)
      .then(res => {
        dispatch(onHideProjectSuccess(res.data));
        dispatch(getProjects(loading));
      })
      .catch(error => {
        dispatch(stopSubmit(PROJECT_DETAIL_FORM, error.response.data.errors));
        dispatch(onHideProjectError());
      });
  };
}

export function completeProjectByMember(projectId) {
  return dispatch => {
    api
      .completeProjectByMember(projectId)
      .then(() => {
        dispatch(push(`/member/review/${projectId}`));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

//Company Projects
export function getProjects(loading = true) {
  return dispatch => {
    dispatch(
      setTableLoading({
        table: PROJECT_INDEX_TABLE,
        loading: loading
      })
    );
    dispatch(onGetProjectsStart());

    api
      .getProjects()
      .then(response => {
        const { data } = response.data;
        dispatch(onGetProjectsSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetProjectsError());
      })
      .finally(() => {
        dispatch(resetTable({ table: PROJECT_INDEX_TABLE }));
      });
  };
}

export function completeProjectByEmployer(Id, memberId) {
  return dispatch => {
    api
      .completeProjectByEmployer(Id)
      .then(() => {
        dispatch(push(`/company/review/${Id}/member/${memberId}`));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

// Filter open projects by default
export function getAdminProjects(
  filters = "?filter[status_id]=1,2,4,5,6,7,8,9"
) {
  return dispatch => {
    dispatch(onGetProjectsStart());
    dispatch(setPagination({}));

    api
      .getAdminProjects(filters)
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(onGetProjectsSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetProjectsError());
      });
  };
}

export function getAdminProjectsCSVData(filters = "") {
  return dispatch => {
    // dispatch(onGetProjectsStart());

    api
      .getAdminProjectsForCSV(filters)
      .then(response => {
        const { data } = response.data;
        dispatch(onGetProjectsCsvSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetProjectsError());
      });
  };
}

export function getSOW(sowId) {
  return dispatch => {
    api
      .getSOW(sowId)
      .then(response => {
        dispatch(setSOW(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

// Member Matches
export function getMatches(loading = true, stats = true) {
  return dispatch => {
    dispatch(
      setTableLoading({
        table: PROJECT_MATCHES_TABLE,
        loading: loading
      })
    );

    api
      .getMatches()
      .then(response => {
        dispatch(resetTable({ table: PROJECT_MATCHES_TABLE }));
        dispatch(setMatches(response.data.data));

        if (stats) {
          dispatch(getUserStats());
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(
          setTableLoading({
            table: PROJECT_MATCHES_TABLE,
            loading: false
          })
        );
      });
  };
}

export function getMatch(matchId, loading = true) {
  return dispatch => {
    dispatch(setLoading(loading));

    api
      .getMatch(matchId)
      .then(response => {
        dispatch(setMatch(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.error));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function runMatchAll() {
  return dispatch => {
    api
      .runMatchAll()
      .then(() => {})
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

export function declineMatch(payload) {
  return dispatch => {
    api
      .declineMatch(payload)
      .then(() => {
        dispatch(resetTable({ table: PROJECT_MATCHES_TABLE }));
        dispatch(getMatches(false));
        dispatch(getUserStats());
      })
      .catch(() => {})
      .finally(() => {});
  };
}

export function storePitch(payload) {
  return dispatch => {
    dispatch(setLoading(true));
    dispatch(startSubmit(PROJECT_PITCH_IT_FORM));

    api
      .storePitch(payload)
      .then(() => {
        dispatch(push("/member/projects/pitches"));
        dispatch(stopSubmit(PROJECT_PITCH_IT_FORM));
      })
      .catch(error => {
        dispatch(showError(error.response.data.error));
        dispatch(stopSubmit(PROJECT_PITCH_IT_FORM, error.response.data.errors));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function updatePitch(id, redirect, payload) {
  return dispatch => {
    dispatch(setLoading(true));
    dispatch(startSubmit(PROJECT_PITCH_IT_FORM));

    api
      .updatePitch(id, payload)
      .then(() => {
        dispatch(push(redirect ? redirect : "/member/projects/pitches"));
        dispatch(stopSubmit(PROJECT_PITCH_IT_FORM));
      })
      .catch(error => {
        dispatch(showError(error.response.data.error));
        dispatch(stopSubmit(PROJECT_PITCH_IT_FORM, error.response.data.errors));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

// Member Pitches
export function getPitches() {
  return dispatch => {
    dispatch(
      setTableLoading({
        table: PROJECT_PITCHES_TABLE,
        loading: true
      })
    );
    dispatch(
      setTableLoading({
        table: PROJECT_SOW_TABLE,
        loading: true
      })
    );

    api
      .getPitches()
      .then(response => {
        dispatch(resetTable({ table: PROJECT_PITCHES_TABLE }));
        dispatch(setPitches(response.data.data));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(resetTable({ table: PROJECT_PITCHES_TABLE }));
        dispatch(resetTable({ table: PROJECT_SOW_TABLE }));
      });
  };
}

export function getPitch(pitchId) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .getPitch(pitchId)
      .then(response => {
        const { data } = response.data;
        dispatch(setPitch(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function storeSOW(payload, projectId) {
  const userRole = localStorage.getItem("role");

  return dispatch => {
    if (userRole === "admin") {
      dispatch(setLoading(true));
    }

    dispatch(startSubmit(PROJECT_SOW_FORM));
    api
      .storeSOW(payload)
      .then(() => {
        if (userRole === "member") {
          dispatch(push("/member/projects/sows"));
        } else if (userRole === "admin") {
          dispatch(getAdminProject(projectId));
        }
        dispatch(stopSubmit(PROJECT_SOW_FORM));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(stopSubmit(PROJECT_SOW_FORM, error.response.data.errors));
      })
      .finally(() => {
        if (userRole === "admin") {
          dispatch(setLoading(false));
        }
      });
  };
}

export function updateSOW(
  sowId,
  payload,
  projectId,
  pitchId = null,
  pathName = null
) {
  const userRole = localStorage.getItem("role");

  return dispatch => {
    dispatch(setLoading(true));

    dispatch(startSubmit(PROJECT_SOW_FORM));
    api
      .updateSOW(sowId, payload)
      .then(() => {
        if (userRole === "employer") {
          dispatch(getPitch(pitchId));
        } else if (userRole === "member") {
          dispatch(getProject(projectId));
        } else if (userRole === "admin") {
          dispatch(getAdminProject(projectId));
        }

        if (pathName) {
          dispatch(push(pathName));
        }
        dispatch(stopSubmit(PROJECT_SOW_FORM));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(stopSubmit(PROJECT_SOW_FORM, error.response.data.errors));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

// Member Statements of work
export function getStatements() {
  return dispatch => {
    dispatch(
      setTableLoading({
        table: PROJECT_SOW_TABLE,
        loading: true
      })
    );

    api
      .getStatements()
      .then(response => {
        dispatch(resetTable({ table: PROJECT_SOW_TABLE }));
        dispatch(setStatements(response.data.data));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(
          setTableLoading({
            table: PROJECT_SOW_TABLE,
            loading: false
          })
        );
      });
  };
}

export function getCandidates() {
  return (dispatch, getState) => {
    const { sortedBy } = getState().project;

    dispatch(setCandidates(candidates.data));
    dispatch(sortCandidates(sortedBy));
  };
}

export function declineCandidate(id) {
  return (dispatch, getState) => {
    const candidate = getState().project.candidates.find(
      candidate => candidate.id === id
    );

    dispatch(
      onDeclineCandidateSuccess({
        ...candidate,
        declined: true,
        declinedOn: moment().format("l")
      })
    );
  };
}

export function sortCandidates(sortBy) {
  return (dispatch, getState) => {
    const { candidates } = getState().project;
    let sorted = candidates;

    switch (sortBy) {
      case "date_pitched":
        sorted = candidates.sort((a, b) => moment(b.date) - moment(a.date));
        break;
      case "name":
        sorted = candidates.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "skills_matched":
        sorted = candidates.sort((a, b) => a.matches.length < b.matches.length);
        break;
    }

    dispatch(setSortedBy(sortBy));
    dispatch(setCandidates(sorted));
  };
}

export function getHired() {
  return dispatch => {
    api
      .getHired()
      .then(response => {
        const { data } = response.data;

        dispatch(setHired(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

export function acceptPitch(payload, projectId) {
  const userRole = localStorage.getItem("role");

  return dispatch => {
    api
      .acceptPitch(payload)
      .then(response => {
        dispatch(getPitch(payload.pitch_id));

        if (userRole === "admin") {
          if (
            response.data &&
            response.data.data &&
            response.data.data.accepted
          ) {
            dispatch(push(`/admin/project/${projectId}/sow`));
          } else {
            dispatch(push(`/admin/project/${projectId}/pitches`));
          }
        }
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(getPitchesByProjectId(projectId, false));
      });
  };
}

export function undoDeclinePitch(projectId, pitchId) {
  const payload = {
    pitch_id: pitchId
  };
  return dispatch => {
    api
      .undoPitch(payload)
      .then(() => {
        dispatch(getPitch(payload.pitch_id));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(getPitchesByProjectId(projectId, false));
      });
  };
}

export function acceptSow(payload, pitchId, projectId) {
  const userRole = localStorage.getItem("role");

  return dispatch => {
    api
      .acceptSow(payload)
      .then(() => {
        dispatch(getPitch(pitchId));

        if (userRole === "admin") {
          dispatch(getAdminProject(projectId));
        }
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

export function getMember(memberId) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .getMemberById(memberId)
      .then(response => {
        const { data } = response.data;

        dispatch(setMember(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

// Company Pitches
export function getPitchesByProjectId(projectId, loading = true) {
  return dispatch => {
    dispatch(setLoading(loading));
    api
      .getPitchesByProjectId(projectId)
      .then(response => {
        dispatch(setPitches(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getMessagesByPitchId(pitchId, loading = true) {
  return dispatch => {
    dispatch(setLoading(loading));
    api
      .getMessagesByPitchId(pitchId)
      .then(response => {
        dispatch(setMessages(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function sendMessage(payload) {
  return dispatch => {
    dispatch(startSubmit(PROJECT_SEND_MESSAGE_FORM));

    api
      .sendMessage(payload)
      .then(() => {
        dispatch(getMessagesByPitchId(payload.get("pitch_id"), false));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(stopSubmit(PROJECT_SEND_MESSAGE_FORM));
        dispatch(reset(PROJECT_SEND_MESSAGE_FORM));
      });
  };
}

export function editMessage(messageId, payload) {
  return dispatch => {
    dispatch(startSubmit(PROJECT_UPDATE_MESSAGE_FORM));

    api
      .updateMessage(messageId, payload)
      .then(() => {
        dispatch(getMessagesByPitchId(payload.get("pitch_id"), false));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(stopSubmit(PROJECT_UPDATE_MESSAGE_FORM));
        dispatch(reset(PROJECT_UPDATE_MESSAGE_FORM));
      });
  };
}

export function removeMessage(messageId, pitchId = null) {
  return dispatch => {
    api
      .removeMessage(messageId)
      .then(() => {
        if (pitchId) {
          dispatch(getMessagesByPitchId(pitchId, false));
        }
      })
      .catch(() => {})
      .finally(() => {});
  };
}

export function downloadMessageAttachment(messageId) {
  return dispatch => {
    dispatch(setLoadingMessageAttachment(true));
    api
      .downloadMessageAttachment(messageId)
      .then(response => {
        window.open(response.data.data, "_blank");
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoadingMessageAttachment(false));
      });
  };
}

export function getStatus() {
  return dispatch => {
    api
      .getStatus()
      .then(response => {
        dispatch(onGetStatusSuccess(response.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(stopSubmit(PROJECT_FILTERS_FORM, error.response.data.errors));
      });
  };
}

export function checkReviewer(projectId, targetId, noRedirection) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .checkReviewer({ project_id: projectId, target_id: targetId })
      .then(response => {
        if (noRedirection) {
          dispatch(setCanSendFeedback(!response.data.data));
        } else if (response.data.data) {
          const userRole = localStorage.getItem("role");
          var link = "/";

          switch (userRole) {
            case "admin":
              link = "/admin/dashboard";
              break;

            case "member":
              link = "/member/projects/matches";
              break;

            case "employer":
              link = "/company/projects";
              break;
          }

          dispatch(push(link));
        } else {
          const userRole = localStorage.getItem("role");

          if (userRole === "member") {
            dispatch(getReviewQuestionsForMember());
          } else if (userRole === "employer") {
            dispatch(getReviewQuestionsForEmployer());
          }
        }
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getReviewQuestionsForMember() {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .getReviewQuestionsForMember()
      .then(response => {
        dispatch(setReviewQuestionsForMembers(response.data.data));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getReviewQuestionsForEmployer() {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .getReviewQuestionsForEmployer()
      .then(response => {
        dispatch(setReviewQuestionsForEmployers(response.data.data));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function storeReview(payload, redirect) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .storeReview(payload)
      .then(() => {
        localStorage.setItem("Review:Id", true);
        dispatch(push(redirect));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function unpauseProject(projectId) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .unpauseProject(projectId)
      .then(() => {
        dispatch(push("/company/projects"));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/project.actions.js